<template>
  <div class="waves ml-2 mt-1 mb-2 mr-2" :class="variant">
    <span class="dot" />
    <span class="dot" />
    <span class="dot" />
  </div>
</template>

<script>
export default {
  name: "ChatLoadingDots",
  components: {},
  props: {
    variant: { type: String, default: null },
  },
  data() {
    return {
      //
    };
  },
  computed: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  methods: {},
};
</script>

<style scoped></style>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
@import "@sass/_mixins.scss";
.waves {
  background: $grey-100;
  border: 1px solid darken($grey-100, 3%);
  position: relative;
  text-align: center;
  width: auto;
  display: inline-block;
  padding: 0.25em 0.5em;
  border-radius: 25px;
  .dot {
    background: $grey-200;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 3px;
    animation: wave 1.3s linear infinite;
    &:nth-child(2) {
      animation-delay: -1.1s;
    }
    &:nth-child(3) {
      animation-delay: -0.9s;
    }
  }
  &.light {
    background: $light;
    border: 1px solid $light;
    .dot {
      background: $dark;
    }
  }
  &.dark {
    background: $dark;
    border: 1px solid $dark;
    .dot {
      background: $light;
    }
  }
  &.danger {
    background: $danger;
    border: 1px solid $danger;
    .dot {
      background: $white;
    }
  }
  &.warning {
    background: $warning;
    border: 1px solid $warning;
    .dot {
      background: $white;
    }
  }
  &.success {
    background: $success;
    border: 1px solid $success;
    .dot {
      background: $white;
    }
  }
  &.primary {
    background: $primary;
    border: 1px solid $primary;
    .dot {
      background: $white;
    }
  }
  &.secondary {
    background: $secondary;
    border: 1px solid $secondary;
    .dot {
      background: $white;
    }
  }
  &.info {
    background: $info;
    border: 1px solid $info;
    .dot {
      background: $white;
    }
  }
}
@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }
  30% {
    transform: translateY(-8px);
  }
}
</style>
